import { NgModule } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';
import { LexiconModule } from '@galaxy/lexicon';
import en from '../../assets/en_devel.json';
import { CreateOrderDialogService } from './dialog/create-order-dialog.service';
import { CreateOrderDialogComponent } from './dialog/create-order-dialog.component';
import { FormatAddressPipe } from './dialog/format-address.pipe';

export const CREATE_ORDER_MODULE_DECLARATIONS = [CreateOrderDialogComponent, FormatAddressPipe];
export const CREATE_ORDER_MODULE_IMPORTS = [
  MatButton,
  MatDialogModule,
  TranslateModule,
  LexiconModule.forChild({
    componentName: 'common/orders',
    baseTranslation: en,
  }),
];
export const CREATE_ORDER_MODULE_PROVIDERS = [CreateOrderDialogService];

@NgModule({
  declarations: CREATE_ORDER_MODULE_DECLARATIONS,
  imports: CREATE_ORDER_MODULE_IMPORTS,
  providers: CREATE_ORDER_MODULE_PROVIDERS,
})
export class CreateOrderModule {}
